import { Button, Col, Drawer, Form, Input, message } from 'antd';
import './style.css';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { DiagnosticService } from 'services/DiagnosticService';
import { useState } from 'react';

function DiagnosticDetail({
  visible,
  activeRecord,
  closeDrawer,
  closeForm,
  getDiagnostic,
}) {
  const [loading, setLoading] = useState(false);
  const { actualRegData, today, taxDebt, journal, saldos } = activeRecord.data;
  const { flRegData, ulRegData } = actualRegData.regData;

  const saveData = async (values) => {
    setLoading(true);
    const filteredArray = values?.answers?.filter(
      (obj) => !!obj.category | !!obj.status
    );
    const filteredArrayRes = values?.results?.filter(
      (obj) => !!obj.category | !!obj.status
    );

    const payload = {
      ...activeRecord.data,
      ...values,
      answers: filteredArray,
      results: filteredArrayRes,
    };

    try {
      const res = await DiagnosticService.saveDiagnostic(payload);
      if (res) {
        getDiagnostic();
        closeDrawer();
        closeForm();
        setLoading(false);
      }
    } catch (error) {
      message.error('Не удалось сохранить диагностику');
      setLoading(false);
    }
  };

  return (
    <Drawer visible={visible} onClose={closeDrawer} width="60%">
      <Form
        onFinish={(values) => {
          saveData(values);
        }}
      >
        <div className="document_diagnostic">
          <div className="main_title first">Диагностика</div>
          <div className="main_info">
            <div className="column_name">Наименование компании</div>
            <div className="column_value">
              {actualRegData?.regData?.names?.ru.name}
            </div>
            <div className="column_name">Руководитель</div>
            <div className="column_value">
              {actualRegData?.regData?.names?.ru?.fio !== ''
                ? actualRegData?.regData?.names?.ru?.fio
                : actualRegData?.regData?.ulRegData?.director?.nameRu}
            </div>
            <div className="column_name">ИИН/БИН</div>
            <div className="column_value">{actualRegData?.regData?.iin}</div>
            <div className="column_name">Режим налогообложения</div>
            <div className="column_value">
              <Form.Item name="tax_regim" noStyle>
                <Input placeholder="Режим налогообложения" />
              </Form.Item>
            </div>
          </div>
          <div className="main_title second">Общие сведение</div>

          <div className="common_info">
            <div className="column_name">Наименование</div>
            <div className="column_name">Сведения</div>
            <div className="column_value">ОКЭД</div>
            <div className="column_value">
              {flRegData?.mainOkeds[0]?.code ?? ulRegData?.mainOkeds[0]?.code} -{' '}
              {flRegData?.mainOkeds[0]?.name ?? ulRegData?.mainOkeds[0]?.name}
            </div>
            <div className="column_value">Юридический адрес</div>
            <div className="column_value">
              {flRegData?.ipAddress ?? ulRegData?.jurAddress}
            </div>
            <div className="column_value">Плательщик НДС</div>
            <div className="column_value">
              {flRegData?.vatSeries
                ? `НДС плательщик  от ${
                    flRegData?.vatRegDate ?? ulRegData?.vatRegDate
                  }, Номер ${flRegData?.vatNumber ?? null}, Серия ${
                    flRegData?.vatSeries ?? ulRegData?.vatSeries
                  }`
                : 'Нет'}
            </div>

            <div className="column_value">Наличие ККМ</div>
            <div className="column_value">
              {flRegData?.kkm || ulRegData?.kkm
                ? 'Есть'
                : 'Нет кассового аппарата'}
            </div>

            <div className="column_value">
              Наличие или отсутствие налоговой задолженности
            </div>
            <div className="column_value">{taxDebt ? 'Есть' : 'Нет'}</div>

            <div className="column_value">
              Сведения о приостановлении (возобновлении) предоставления
              налоговой отчетности
            </div>
            <div className="column_value">
              <Form.Item name="stopped" noStyle>
                <Input placeholder="Введите сведения о налоговой отчётности" />
              </Form.Item>
            </div>
            <div className="column_value">Сотрудники</div>
            <div className="column_value">
              <Form.Item name="employees" noStyle>
                <Input placeholder="Введите сотрудников" />
              </Form.Item>
            </div>
            {journal.map((i) => (
              <>
                <div className="column_value">Отчет ФНО</div>
                <div className="column_value">
                  Форма {i.formCode} {i.docPeriod.year} г.{' '}
                  {i.docPeriod.period.nameRu ?? null} ({i?.status?.nameRu})
                </div>
              </>
            ))}

            {saldos.map((i) => (
              <>
                <div className="column_value">{i.ruName}</div>
                <div className="column_value">
                  Сальдо {i.tax} | Пеня {i.penalty} | Штраф {i.fine}
                </div>
              </>
            ))}
          </div>
          <div className="main_title second">Результат диагностики</div>

          <div className="common_info diagnostic_results">
            <div className="column_name">Категория</div>
            <div className="column_name">Статус</div>
            <div className="column_name">Сведения</div>
            <Form.List name="results">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name }) => (
                    <>
                      <Form.Item key={key} name={[name, 'category']} noStyle>
                        <Input placeholder="Введите категорию" />
                      </Form.Item>
                      <Form.Item name={[name, 'status']} noStyle>
                        <Input placeholder="Введите статус" />
                      </Form.Item>
                      <div style={{ display: 'flex' }}>
                        <Form.Item name={[name, 'info']} noStyle>
                          <Input
                            style={{ width: '93%' }}
                            placeholder="Введите сведения"
                          />
                        </Form.Item>
                        <Button
                          icon={<DeleteOutlined />}
                          style={{
                            height: '32px',
                            width: '7%',
                          }}
                          onClick={() => remove(name)}
                        />
                      </div>
                    </>
                  ))}
                  <Col>
                    <Form.Item>
                      <Button
                        icon={<PlusOutlined />}
                        style={{ marginBottom: '20px' }}
                        onClick={() => add()}
                      >
                        Добавить результат диагностики
                      </Button>
                    </Form.Item>
                  </Col>
                </>
              )}
            </Form.List>
          </div>

          <div className="main_title second">Решение диагностики</div>

          <div className="common_info diagnostic_answer">
            <div className="column_name">Категория</div>
            <div className="column_name">Статус</div>
            <div className="column_name">Сведения</div>
            <div className="column_name bg_cm">Сумма</div>
            <Form.List name="answers">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name }) => (
                    <>
                      <Form.Item key={key} name={[name, 'category']} noStyle>
                        <Input placeholder="Введите категорию" />
                      </Form.Item>
                      <Form.Item name={[name, 'status']} noStyle>
                        <Input placeholder="Введите статус" />
                      </Form.Item>
                      <Form.Item name={[name, 'info']} noStyle>
                        <Input placeholder="Введите сведения" />
                      </Form.Item>

                      <div style={{ display: 'flex' }}>
                        <Form.Item name={[name, 'summ']} noStyle>
                          <Input
                            style={{ width: '75%' }}
                            placeholder="Введите сумму"
                          />
                        </Form.Item>
                        <Button
                          icon={<DeleteOutlined />}
                          style={{
                            height: '32px',
                            width: '25%',
                          }}
                          onClick={() => remove(name)}
                        />
                      </div>
                    </>
                  ))}
                  <Col>
                    <Form.Item>
                      <Button
                        icon={<PlusOutlined />}
                        style={{ marginBottom: '20px' }}
                        onClick={() => add()}
                      >
                        Добавить решение диагностики
                      </Button>
                    </Form.Item>
                  </Col>
                </>
              )}
            </Form.List>
          </div>
          <div className="common_info text">
            <div className="simple">
              <Form.Item name="byDoneForm" noStyle>
                <Input placeholder="Введите ФИО сотрудника и должность" />
              </Form.Item>
            </div>
            <div className="simple">{today}</div>
            <div className="border height" />
            <div className="border height" />
            <div className="blue">(ФИО сотрудника, должность)</div>
            <div className="blue">(Дата)</div>
          </div>
        </div>

        <Form.Item>
          <Button
            loading={loading}
            type="primary"
            htmlType="submit"
            icon={<PlusOutlined />}
          >
            Сохранить диагностику
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { DiagnosticDetail };
